<script lang="ts">
  import Error from '$lib/components/Error.svelte';
  import LobbyTabs from '$lib/components/LobbyTabs.svelte';
  import PageTitle from '$lib/components/PageTitle.svelte';
  import PlayersInQueuePopup from "$lib/components/PlayersInQueuePopup.svelte";
  import dayjs from 'dayjs';
  import { onMount, setContext } from 'svelte';
  import { writable } from 'svelte/store';

  export let data;

  let maxTime = data.metadata.lastLobbyTime;
  let numbers = data.lobbyNumbers;
  $: lastLobbyTime = dayjs(maxTime * 1000).diff(dayjs(), 'minute');
  const autoFetch = writable(true);
  setContext('autoFetch', autoFetch);

  const autoRefetchMilliseconds = 5000;
  let autoRefetchInterval: ReturnType<typeof setTimeout> | null = null;
  const refetchMetadata = async () => {
    if (!$autoFetch) return;
    const res = fetch(`/api/lobbies/metadata`);
    const json = await res.then((r) => r.json());
    maxTime = json.metadata.lastLobbyTime;
    numbers = json.lobbyNumbers;
    data.playersInQueue = json.playersInQueue;
  };

  onMount(() => {
    autoRefetchInterval = setInterval(refetchMetadata, autoRefetchMilliseconds);
    return () => {
      if (autoRefetchInterval) clearInterval(autoRefetchInterval);
    };
  });
</script>

<svelte:head>
  <title>Lobbies - aomstats</title>
  <meta name="description" content="Lobby browser for active ranked lobbies in Age of Mythology: Retold" />
  <meta property="og:title" content="Lobbies - aomstats" />
  <meta property="og:description" content="Lobby browser for active ranked lobbies in Age of Mythology: Retold" />
  <meta property="og:image" content="https://aomstats.io/favicon.png" />
</svelte:head>

<PageTitle>Current Lobbies ({numbers.custom + numbers.ranked + numbers.joinable})</PageTitle>

<!-- <Info>You can now copy the game URL by clicking the clipboard icon and search for it in the lobby browser.</Info> -->

{#if lastLobbyTime < -2}
  <Error>
    🚨
    <span class="font-bold">Warning:</span> The last lobby is over 5 minutes old! Page might be broken! 🚨
  </Error>
{/if}

<LobbyTabs numCustom={numbers.custom} numRanked={numbers.ranked} numJoinable={numbers.joinable} />

<slot />

<PlayersInQueuePopup playersInQueue={data.playersInQueue} />
